// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Additional Device Type Components from database.
 * @see #/components/schemas/AdditionalDeviceTypeComponent - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdditionalDeviceTypeComponent {
    readonly code: string;
    /**
     * The display name for the additional device
     *
     */
    display_name?: string;
    /**
     * The type for the additional device  * `integer` - Integer * `decimal` - Dezimal * `text` - Text * `boolean` - Boolean
     *
     */
    type?: AdditionalDeviceTypeComponent.TypeEnum | null;
    /**
     * The unit for the additional device (required for integer and decimal types)
     *
     */
    unit?: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdditionalDeviceTypeComponent
 */
export namespace AdditionalDeviceTypeComponent {
    export type TypeEnum = 'integer' | 'decimal' | 'text' | 'boolean' | 'null';
    export const TypeEnum = {
        Integer: 'integer' as TypeEnum,
        Decimal: 'decimal' as TypeEnum,
        Text: 'text' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Null: 'null' as TypeEnum,
    };

    /**
     * AdditionalDeviceTypeComponent Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        readonly code: string;
        /**
         * The display name for the additional device
         * @type string (`dataFormat` is missing)
         */
        displayName?: string;
        /**
         * The type for the additional device  * `integer` - Integer * `decimal` - Dezimal * `text` - Text * `boolean` - Boolean
         * @type string (`dataFormat` is missing)
         */
        type?: AdditionalDeviceTypeComponent.TypeEnum | null;
        /**
         * The unit for the additional device (required for integer and decimal types)
         * @type string (`dataFormat` is missing)
         */
        unit?: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdditionalDeviceTypeComponent DTO
     * Transforms AdditionalDeviceTypeComponent model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdditionalDeviceTypeComponent model */
        static toModel(obj: AdditionalDeviceTypeComponent): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdditionalDeviceTypeComponent model */
        static toApi(obj: Model): AdditionalDeviceTypeComponent {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdditionalDeviceTypeComponent;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
